import React, {useMemo} from 'react'
import Page from "../Page";
import LoadingBanner from "../../components/LoadingBanner";
import RequestButton from "../../components/RequestButton";
import TalentPortal from "../talent-portal/TalentPortal";
import OpportunityDetails from "./OpportunityDetails";
import {useLocation, useNavigate} from "react-router-dom";
import {useOpportunity} from "../../providers/OpportunityProvider";
import {useAuth} from "../../providers/AuthProvider";

const OppTeamStatusTable = (props) => {
    let {
        opportunity,
        isDisabled,
        onRequest
    } = useOpportunity();

    const sendReminder = (member) => {
        if (isDisabled) return;

        return onRequest(() => opportunity.remindMember(member))
    }
    const members = useMemo(() => {
        return opportunity.teamMembers()
    }, [isDisabled, opportunity]);

    const {auth} = useAuth();


    if (!auth || !opportunity) {
        return null;
    }
    return (
        <table className="table table-bordered team-status-modal-table">
            <thead>
            <tr>
                <th>Name</th>
                <th>Type</th>
                <th>Status</th>
            </tr>
            </thead>
            <tbody>
            {members.map(member => {

                let dontRemind = !member.talent_opp_id || member.id === auth.id
                    || member.accepted_at
                    || member.rejected_at
                    || props.stepDisabled;

                return (
                    <tr key={`member-${member.id}`}>
                        <td className="team-member-name">
                            <p>
                                {member.firstNamePlusInitial()} {member.id === auth.id && (
                                <span className="text-danger ml-1">
                                    (You)
                                </span>
                            )}
                            </p>
                        </td>
                        <td className="team-member-role">
                            <p>
                                {member.is_admin ? 'Admin' : 'Member'}
                            </p>
                        </td>
                        <td className="team-member-status">
                            <div className="flex flex-row justify-center items-center">
                                {dontRemind ? (
                                    <p className={TB.mapClass({
                                        'text-success': member.accepted_at,
                                        'text-danger': !member.accepted_at && member.rejected_at,
                                        'text-muted': !member.accepted_at && !member.rejected_at,
                                    })}>
                                        {member.accepted_at && 'Pursued'}

                                        {!member.accepted_at && member.rejected_at && 'Passed'}

                                        {!member.accepted_at && !member.rejected_at && 'No Response'}
                                    </p>
                                ) : (
                                    <RequestButton
                                        onRequest={() => sendReminder(member)}
                                        disabled={!member.can_remind_to_accept || member.reminded_to_accept_at}
                                        className={TB.mapClass("btn btn-primary", {
                                            'no-click': isDisabled
                                        })}>
                                        {(!member.can_remind_to_accept || member.reminded_to_accept_at) ?
                                            `Reminded: ${TB.moment(member.reminded_to_accept_at).format('ll')}`
                                            : 'Send Reminder'
                                        }
                                    </RequestButton>
                                )}
                            </div>
                        </td>
                    </tr>
                )
            })}
            </tbody>
        </table>
    )
}
export default class OppTeamStatusStep extends Page {

    static path = '/pursuit-status';

    static title = 'Pursuit Status';

    static isLocked(opportunity) {
        return false
    }
    static accomplishedForOpportunity(opportunity) {
        return opportunity.isProposing() || opportunity.isPendingContract() || opportunity.hasSignedContract()
    }

    constructor(props) {
        super(props);

        this.formRef = React.createRef();

        this.state = {
            ...this.state,
            isLoading: true,
        }
    }

    componentDidMount() {
        super.componentDidMount();
        this.middlewareCheck(() => this.promisedState({isLoading: false}))
    }

    validateProjectMiddleware() {
        let opportunity = this.props.opportunity;

        return false
    }

    async middlewareCheck(callback = () => {
    }) {
        let error = this.validateProjectMiddleware();

        if (!error) {
            return callback();
        }

        await TB.sysAlert(error.key);

        return this.props.navigate('..' + error.redirect.path, {replace: true});
    }

    async acceptForTeam() {
        await this.props.onUpdate({
            accepted_for_team_at: new Date()
        });

        await TB.sysAlert('talent.opportunity_accepted_for_team')
        this.props.navigate({
            pathname: OpportunityDetails.pathForOpp(
                this.props.opportunity,
                this.props.opportunity.currentProjectStep()
            )
        })
    }

    async rejectForTeam() {
        await this.props.onUpdate({
            rejected_for_team_at: new Date()
        });

        await TB.sysAlert('talent.opportunity_rejected_for_team');

        await this.props.navigate(TB.auth().appropriate(), {replace: true});
    }

    async withdrawFromOpportunity()
    {
        let didWithdraw = await this.props.opportunity.withdrawInterest(
            this.props.onUpdate
        );
        if (!didWithdraw) {
            return;
        }

        await this.props.navigate({
            pathname: TalentPortal.projectsListPath(
                this.props.opportunity.displayStatus()
            )
        }, {replace: true});
    }

    render() {
        let {
            opportunity,
            isDisabled,
        } = this.props;


        return (
            <div className="talent-portal-container">
                <div className="talent-portal-page-container talent-opportunity-container pt-6 p-3">

                    <div className="talent-opp-wizard-header talent-opportunity-brief-btns">

                        <h2>Pursuit Status</h2>

                        {opportunity.can_be_withdrawn && (
                            <div className="flex flex-row items-center ml-auto">
                                <p>This Opportunity</p>
                                <button className="btn btn-dark"
                                        disabled={this.props.isDisabled}
                                        onClick={this.withdrawFromOpportunity.bind(this)}>
                                    Withdraw Interest
                                </button>
                            </div>
                        )}

                    </div>
                    {this.state.isLoading && <LoadingBanner message="Loading Team Status"/>}

                    {!this.state.isLoading && (
                        <div className="talent-project-team-status-panel opportunity-team-status-modal p-3">
                            <div className="panel-header m-0">
                                Team Status for {opportunity.team.name}
                            </div>
                            <div className="panel-subheader">
                                Project: {opportunity.project.name}
                            </div>

                            <div className="team-status-modal-container">

                                {/*{this.renderTeamStatus()}*/}

                                <OppTeamStatusTable stepDisabled={this.constructor.accomplishedForOpportunity(opportunity)}/>
                                <div className={TB.mapClass("team-status-modal-footer", {
                                    'flex-row': opportunity.canAdmin()
                                })}>
                                    <div className="modal-footer-title">
                                        Status: {!this.constructor.accomplishedForOpportunity(opportunity) ?
                                        'PENDING DECISION TO PURSUE'
                                        : 'PURSUED BY TEAM'
                                    }
                                    </div>
                                    {opportunity.canAdmin() ? (
                                        this.constructor.accomplishedForOpportunity(opportunity) ? <div/> : [
                                            <button
                                                key="reject-opp-btn"
                                                onClick={() => this.rejectForTeam()}
                                                disabled={isDisabled || !opportunity.canRejectForTeam() || this.state.isDisabled}
                                                className="btn btn-dark mr-3">
                                                Reject Opportunity for Team
                                            </button>,
                                            <button
                                                key="accept-opp-btn"
                                                onClick={() => this.acceptForTeam()}
                                                disabled={isDisabled || !opportunity.canAcceptForTeam() || this.state.isDisabled}
                                                className="btn btn-primary">
                                                Pursue Opportunity for Team
                                            </button>

                                        ]
                                    ) : (
                                        <p className="text-muted"
                                           dangerouslySetInnerHTML={{__html: TB.trans('talent.team_status_modal_member_info')}}/>
                                    )}
                                </div>
                            </div>

                        </div>
                    )}
                </div>
            </div>
        );
    }
}


const OppTeamStatusTab = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const {
        onRequest,
        onUpdate,
        opportunity,
        isDisabled
    } = useOpportunity()

    return (
        <OppTeamStatusStep location={location} navigate={navigate} onRequest={onRequest}
                         onUpdate={onUpdate}
                         opportunity={opportunity}
                         isDisabled={isDisabled}/>
    )
}

export {
    OppTeamStatusTab
}